import { useEffect, useState } from 'react';

/**
 * "6d 4h" / "3h 12m" / "under a minute" until expiry, refreshed every minute;
 * 'expired' past the deadline; null when inactive. Shared by the offer review
 * screen and the offers-list cards.
 */
export const useExpiryCountdown = (
  expiresAt: string | undefined,
  active: boolean
): string | null => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(id);
  }, [active]);
  if (!expiresAt || !active) return null;
  const ms = new Date(expiresAt).getTime() - now;
  if (Number.isNaN(ms) || ms <= 0) return 'expired';
  const minutes = Math.floor(ms / 60_000);
  const days = Math.floor(minutes / (60 * 24));
  const hours = Math.floor((minutes % (60 * 24)) / 60);
  const mins = minutes % 60;
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${mins}m`;
  if (mins > 0) return `${mins}m`;
  return 'under a minute';
};

export default useExpiryCountdown;
